import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelayService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) {
  }

  getSettings(): Observable<RelaySettingsDto[]> {
    return this.http.get<RelaySettingsDto[]>(`${this.baseurlService.getBaseUrl()}/relay`);
  }

  setSettings(id: number, r: RelaySettingsSetDto): Observable<string> {
    return this.http.put<string>(`${this.baseurlService.getBaseUrl()}/relay/${id}`, r);
  }

}


export interface RelaySettingsDto {
  id: number;
  mac: string;
  name: string;
  flip: boolean;
  manualStatus: boolean;
  resetManualStatusAtNextSchedule: boolean;
  manualStatusCreated: string;
}


export interface RelaySettingsSetDto {
  manualStatus: boolean;
  resetManualStatusAtNextSchedule: boolean;
}
